<template>
  <div class="page" :class="{ 'view-history': !search }">
    <PreviewAlert v-if="isPreview" :id="_id" @close="isPreview = false" />
    <div class="page-bg"></div>
    <div class="page-header">
      <div class="page-header-start">
        <h3 class="page-title">ບໍລິສັດ ຂໍຖອນເຢຍໂລ້ລິສ</h3>
        <button
          class="button info"
          @click="openForm = true"
          v-if="permission !== 'finance'"
        >
          ເພີ່ມບໍລິສັດ ຂໍຖອນເຢຍໂລ້ລິສ
        </button>
      </div>
      <div class="page-header-end">
        <button
          class="button primary small"
          v-if="search"
          @click="(search = !search), fetch()"
        >
          <i class="fa-regular fa-clock-rotate-left"></i>
          ເບິ່ງປະຫວັດທີ່ຂໍຖອນເຢຍໂລ້ລິສ
        </button>

        <button
          v-else
          class="button danger small"
          @click="(search = !search), fetch()"
        >
          <i class="fa-regular fa-clock-rotate-left"></i>
          ປິດປະຫວັດທີ່ຂໍຖອນເຢຍໂລ້ລິສ
        </button>
      </div>
    </div>
    <div class="page-body">
      <table class="table">
        <thead>
          <tr>
            <th class="is-5 text-center">ລ/ດ</th>
            <th class="is-5">ໂລໂກ້</th>
            <th class="is-20">ບໍລິສສັດ</th>
            <th class="is-10 text-center">ວັນທີຂໍຖອນ</th>
            <th class="">ເຫດຜົນ</th>
            <th class="is-10 text-center">ຜູ້ຂໍຖອນຈາກເຢຍໂລ້ລິສ</th>
            <th
              class="is-10 text-center"
              v-if="search && permission === 'finance'"
            >
              ເບີ່ງລາຍລະອຽດ
            </th>
            <th
              class="text-right is-5"
              v-if="search && permission === 'finance'"
            >
              ໂຕເລືອກ
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(i, index) in info" :key="index">
            <td class="text-center">{{ index + 1 }}</td>
            <td>
              <img :src="$urlImageShow + i.logo" />
            </td>
            <td>{{ i.companyName }}</td>
            <td class="text-center">
              {{ i.createdAt }}
            </td>
            <td>
              {{ i.reasonRequest }}
              <span
                @click="openModalEdit(i._id)"
                class="edit"
                v-if="search && permission !== 'finance'"
              >
                <i class="fa-solid fa-pen"></i>
              </span>
            </td>
            <td class="text-center">{{ i.auth }}</td>
            <td class="text-right" v-if="search && permission === 'finance'">
              <span
                class="button"
                @click="(_id = i._id), (isPreview = true)"
                v-if="permission === 'finance'"
                >ລາຍລະອຽດ</span
              >
            </td>
            <td class="text-right" v-if="search && permission === 'finance'">
              <span
                :class="[
                  'button primary',
                  { 'is-loading': loading && index === isIndex },
                ]"
                @click="unlockYellow(i._id, index)"
                v-if="permission === 'finance'"
                >ປົດລ໋ອກ</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <yellowlistForm v-if="openForm" @cancel="(openForm = false), fetch()" />
  </div>
</template>
<script>
import yellowlistForm from "./yellowlistForm.vue";
import { apolloClient } from "@/services/apollo-client";
import {
  GET_YELLOWLIST,
  UNYELLOWLIST_EMPLOYER,
} from "@/graphql/blacklist/yellowlist.js";
import PreviewAlert from "./preview.vue";
export default {
  components: { yellowlistForm, PreviewAlert },
  data: () => ({
    openForm: false,
    info: [],
    msg: "",
    status: true,
    isLoading: false,
    err: "",
    page: 1,
    perPage: 1000,
    search: true,
    permission: "",
    isPreview: false,
    _id: "",
    loading: false,
    isIndex: null,
  }),
  methods: {
    async openModalEdit(id) {
      this.$router
        .push({
          name: "yellowlist",
          query: {
            id: id,
          },
        })
        .catch(() => {});
      this.openForm = !this.openForm;
    },
    async unlockYellow(id, index) {
      this.loading = true;
      this.isIndex = index;
      setTimeout(async () => {
        await apolloClient.mutate({
          mutation: UNYELLOWLIST_EMPLOYER,
          variables: { _id: id },
        });
        this.fetch();
        this.loading = false;
      }, 1500);
    },
    async fetch() {
      const res = await apolloClient.query({
        query: GET_YELLOWLIST,
        variables: {
          type: this.$route.query.type,
          page: this.page,
          perPage: this.perPage,
          search: this.search,
        },
      });
      this.info = res.data.get_YellowList.info;
    },
  },
  watch: {
    "$store.getters.isAuthInfo": {
      handler() {
        if (
          this.$store.getters.isAuthInfo &&
          this.$store.getters.isAuthInfo !== null
        ) {
          this.permission = this.$store.getters.isAuthInfo;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.fetch();
  },
};
</script>
<style lang="scss" scoped>
.lock {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(var(--alert-color-rgb), 0.15);
  color: var(--alert-color);
  width: 30px;
  height: 30px;
  cursor: pointer;

  &::after {
    content: "";
    font-family: "Font Awesome 6 Pro";
    font-size: 1rem;
    content: "\f023";
    transition: all ease-in-out 0.2s;
    font-weight: 700;
  }

  &:hover {
    &::after {
      content: "\f09c";
      font-weight: 500;
    }
  }
}

.view-history {
  background-color: var(--light-grey-color);

  .page-bg {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(#000, 0.7);
    z-index: 6;
  }

  table {
    position: relative;
    z-index: 7;
  }
}

.page-body {
  padding: 30px;
  flex-grow: 1;
  overflow: auto;
}

.table {
  width: 100%;
  overflow: hidden;

  th {
    white-space: nowrap;

    &.is-5 {
      width: 5% !important;
    }

    &.is-10 {
      width: 10% !important;
    }

    &.is-20 {
      width: 20% !important;
    }

    &.is-30 {
      width: 30%;
    }
  }

  td {
    vertical-align: top;

    .edit {
      background-color: rgba(var(--primary-color-rgb), 0.09);

      &:hover {
        background-color: var(--primary-color);
        transition: all ease-in-out 0.3s;
        cursor: pointer;

        i {
          color: #fff;
        }
      }

      i {
        margin: 0;
        color: var(--primary-color);
      }
    }

    img {
      width: 80px;
    }
  }
}

.page-header {
  border-bottom: 1px solid var(--border-color);
  padding: 20px 30px;
  margin-bottom: 0;

  .page-header-end button {
    z-index: 7;
  }

  .selected {
    background-color: rgb(52, 115, 218);
    color: #ffffff;
  }
}
</style>
